import { exhaustiveGuard } from '../helpers.js';

const PILLARS = {
  UPLOAD_RELEASE: "UPLOAD_RELEASE",
  EDIT_RELEASE: "EDIT_RELEASE",
  AUTH: "AUTH",
  MINTING: "MINTING",
  WITHDRAWAL: "WITHDRAWAL",
  ARTIST_VERIFICATION: "ARTIST_VERIFICATION",
  // For generic transaction cases where it is not straight forward to determine the user facing pillar
  TRANSACTION: "TRANSACTION",
  // For errors that are logged at the global level where determining the pillar isn't practical
  GLOBAL: "GLOBAL",
  AUDIO: "AUDIO",
  POSTING: "POSTING"
};
const FEATURES = {
  SEARCH: "SEARCH",
  PLAYLISTS: "PLAYLISTS",
  BACKED_ARTISTS: "BACKED_ARTISTS",
  FOLLOW_SUBSCRIBE: "FOLLOW_SUBSCRIBE",
  AUDIENCE: "AUDIENCE",
  NOTIFICATION_EMAIL: "NOTIFICATION_EMAIL",
  NOTIFICATIONS: "NOTIFICATIONS",
  ARTIST_COMMUNITY: "ARTIST_COMMUNITY",
  LANDING_PAGE: "LANDING_PAGE"
};
const ERROR_TYPE = {
  MISSING_DRAFT_DATA: "MISSING_DRAFT_DATA",
  ARWEAVE: "ARWEAVE",
  UPLOAD_EDITION: "UPLOAD_EDITION",
  EDIT_EDITION: "EDIT_EDITION",
  MISSING_DRAFT_SPLITS_INFO: "MISSING_DRAFT_SPLITS_INFO",
  MISSING_SPLIT_ADDRESS: "MISSING_SPLIT_ADDRESS",
  EMPTY_ALLOWLIST: "EMPTY_ALLOWLIST",
  INVALID_EDITION_CUTOFF: "INVALID_EDITION_CUTOFF",
  MISSING_SALT_FOR_EDITION: "MISSING_SALT_FOR_EDITION",
  INFLECTION_PRICE_ZERO: "INFLECTION_PRICE_ZERO",
  INFLECTION_POINT_ZERO: "INFLECTION_POINT_ZERO",
  FREE_SALE_MAX_MINTS_PER_WALLET: "FREE_SALE_MAX_MINTS_PER_WALLET",
  MISSING_MERKLE_ROOT: "MISSING_MERKLE_ROOT",
  SWITCHING_CHAINS_ERROR: "SWITCHING_CHAINS_ERROR",
  ARWEAVE_PER_USER_BUDGET_EXCEEDED: "ARWEAVE_PER_USER_BUDGET_EXCEEDED",
  VALIDATION_FAILED: "VALIDATION_FAILED",
  RELEASE_FETCH_MINT_DATA: "RELEASE_FETCH_MINT",
  BLOCK_LISTENER: "BLOCK_LISTENER",
  EDITION_MINT: "EDITION_MINT",
  PAPER_CC: "PAPER_CC",
  CROSSMINT_CC: "CROSSMINT_CC",
  ARTIST_CONTRACT_MINT: "ARTIST_CONTRACT_MINT",
  SAM_SELL_FAILED: "SAM_SELL_FAILED",
  SAM_MINT_FAILED: "SAM_MINT_FAILED",
  SIGNER_NOT_FOUND: "SIGNER_NOT_FOUND",
  DRAFT_ALREADY_EXISTS: "DRAFT_ALREADY_EXISTS",
  RELEASES_WITHDRAW_FAILED: "RELEASES_WITHDRAW_FAILED",
  UNKNOWN: "UNKNOWN",
  REFFERALS_WITHDRAW_FAILED: "REFFERALS_WITHDRAW_FAILED",
  LOCAL_STORAGE: "LOCAL_STORAGE",
  MISSING_RELEASE: "MISSING_RELEASE",
  MISSING_CHAIN_ID: "MISSING_CHAIN_ID",
  NOT_SIGNED_IN: "NOT_SIGNED_IN",
  MISSING_AUCTION_TYPE: "MISSING_AUCTION_TYPE",
  MISSING_SAM_CONFIG: "MISSING_SAM_CONFIG",
  MISSING_EDITS: "MISSING_EDITS",
  DEPLOY_SPLITS_TRANSACTION_FAILED: "DEPLOY_SPLITS_TRANSACTION_FAILED",
  CREATE_DRAFT_EDITION_TRANSACTION_FAILED: "CREATE_DRAFT_EDITION_TRANSACTION_FAILED",
  NFT_TXN_UPSERT_MUTATION_FAILED: "NFT_TXN_UPSERT_MUTATION_FAILED",
  CANCELLED_TRANSACTION: "CANCELLED_TRANSACTION",
  MISSING_TRANSACTION_HASH: "MISSING_TRANSACTION_HASH",
  TRANSACTION_REGISTER_ERROR: "TRANSACTION_REGISTER_ERROR",
  NFT_UPSERT_MUTATION_ERROR: "NFT_UPSERT_MUTATION_ERROR",
  IFRAME_ERROR: "IFRAME_ERROR",
  MISSING_NFT_ID: "MISSING_NFT_ID",
  UNIQUE_CONSTRAINT_ERROR: "UNIQUE_CONSTRAINT_ERROR",
  SIGN_MESSAGE_ERROR: "SIGN_MESSAGE_ERROR",
  MISSING_SIGNATURE: "MISSING_SIGNATURE",
  FETCH_GQL_ERROR: "FETCH_GQL_ERROR",
  DEEP_LINK_ERROR: "DEEP_LINK_ERROR",
  INVALIDATE_QUERIES_ERROR: "INVALIDATE_QUERIES_ERROR",
  UNHANDLED_CONTRACT_METHOD: "UNHANDLED_CONTRACT_METHOD",
  TWITTER_VERIFY_ERROR: "TWITTER_VERIFY_ERROR",
  TWITTER_REMOVE_ERROR: "TWITTER_REMOVE_ERROR",
  INSTAGRAM_VERIFY_ERROR: "INSTAGRAM_VERIFY_ERROR",
  INSTAGRAM_REMOVE_ERROR: "INSTAGRAM_REMOVE_ERROR",
  EMAIL_VERIFY_ERROR: "EMAIL_VERIFY_ERROR",
  SET_AVATAR_ERROR: "SET_AVATAR_ERROR",
  MISSING_FIELDS: "MISSING_FIELDS",
  EMAIL_SEND_ERROR: "EMAIL_SEND_ERROR",
  FETCH_SEARCH_RESULTS_FAILED: "FETCH_SEARCH_RESULTS_FAILED",
  MISSING_AUDIO_DATA: "MISSING_AUDIO_DATA",
  AUDIO_BLOB_ERROR: "AUDIO_BLOB_ERROR",
  GRAPHQL_CLIENT_ERROR: "GRAPHQL_CLIENT_ERROR",
  GLOBAL_ERROR: "GLOBAL_ERROR",
  GLOBAL_UNHANDLED_PROMISE: "GLOBAL_UNHANDLED_PROMISE",
  RESERVOIR_MINT: "RESERVOIR_MINT",
  MISSING_ARTIST_COMMUNITY_CSV_FILE: "MISSING_ARTIST_COMMUNITY_CSV_FILE",
  DOWNLOAD_ARTIST_COMMUNITY_CSV_FILE_ERROR: "DOWNLOAD_ARTIST_COMMUNITY_CSV_FILE_ERROR",
  PARSE_ERROR: "PARSE_ERROR",
  VIRAL_SOUNDS_FETCH_ERROR: "VIRAL_SOUNDS_FETCH_ERROR",
  TOP_COLLECTORS_FETCH_ERROR: "TOP_COLLECTORS_FETCH_ERROR",
  UPVOTING_ERROR: "UPVOTING_ERROR",
  USER_BACKEND_PERSISTED_DATA_UPDATE_ERROR: "USER_BACKEND_PERSISTED_DATA_UPDATE_ERROR",
  RATE_LIMIT: "RATE_LIMIT",
  POSTING: "POSTING"
};
const UPLOAD_RELEASE_ERROR_ACTIONS = {
  RELEASE_DRAFT_DEPLOY_ERROR: "RELEASE_DRAFT_DEPLOY_ERROR",
  RELEASE_DRAFT_INCORRECT_CHAIN_ERROR: "RELEASE_DRAFT_INCORRECT_CHAIN_ERROR",
  RELEASE_DRAFT_ALLOWLIST_ERROR: "RELEASE_DRAFT_ALLOWLIST_ERROR",
  RELEASE_UPLOAD_CREATE_DRAFT_FAILED: "RELEASE_UPLOAD_CREATE_DRAFT_FAILED",
  RELEASE_UPLOAD_SAVE_FAILED: "RELEASE_UPLOAD_SAVE_FAILED",
  RELEASE_UPLOAD_INCORRECT_CHAIN_ERROR: "RELEASE_UPLOAD_INCORRECT_CHAIN_ERROR",
  RELEASE_DRAFT_DELETE_ERROR: "RELEASE_DRAFT_DELETE_ERROR"
};
const EDIT_RELEASE_ERROR_ACTIONS = {
  EDIT_RELEASE_UPDATE_ERROR: "EDIT_RELEASE_UPDATE_ERROR",
  EDIT_RELEASE_SAVE_FAILED: "EDIT_RELEASE_SAVE_FAILED",
  EDIT_RELEASE_VALIDATION_FAILED: "EDIT_RELEASE_VALIDATION_FAILED",
  EDIT_RELEASE_INCORRECT_CHAIN_ERROR: "EDIT_RELEASE_INCORRECT_CHAIN_ERROR",
  EDIT_RELEASE_ALLOWLIST_ERROR: "EDIT_RELEASE_ALLOWLIST_ERROR",
  EDIT_RELEASE_PROCESSING_EDIT_ERROR: "EDIT_RELEASE_PROCESSING_EDIT_ERROR",
  EDIT_RELEASE_REQUEST_EDIT_ERROR: "EDIT_RELEASE_REQUEST_EDIT_ERROR"
};
const AUTH_ERROR_ACTIONS = {
  LOG_OUT_ERROR: "LOG_OUT_ERROR",
  LOG_IN_ERROR: "LOG_IN_ERROR",
  AUTH_EFFECT_ERROR: "AUTH_EFFECT_ERROR"
};
const MINTING_ERROR_ACTIONS = {
  RELEASE_MINT_DATA_FETCH_ERROR: "RELEASE_MINT_DATA_FETCH_ERROR",
  SAM_SELL_EDITION_ERROR: "SAM_SELL_EDITION_ERROR",
  SAM_MINT_EDITION_ERROR: "SAM_MINT_EDITION_ERROR",
  BLOCK_LISTENER_ERROR: "BLOCK_LISTENER_ERROR",
  EDITION_MINT_ERROR: "EDITION_MINT_ERROR",
  TIERED_EDITION_MINT_ERROR: "TIERED_EDITION_MINT_ERROR",
  PAPER_ERROR: "PAPER_ERROR",
  CROSSMINT_ERROR: "CROSSMINT_ERROR",
  ARTIST_CONTRACT_MINT_ERROR: "ARTIST_CONTRACT_MINT_ERROR",
  SIGNER_NOT_FOUND_ERROR: "SIGNER_NOT_FOUND_ERROR",
  NFT_UPSERT_ERROR: "NFT_UPSERT_ERROR",
  ONRAMP_MODAL_ERRROR: "ONRAMP_MODAL_ERRROR",
  SET_COMMENT_TIMESLOT_ERROR: "SET_COMMENT_TIMESLOT_ERROR",
  SET_COMMENT_ERROR: "SET_COMMENT_ERROR",
  SET_REFERRAL_SOURCE_ERROR: "SET_REFERRAL_SOURCE_ERROR",
  BUY_MARKEPLACE_TOKEN: "BUY_MARKEPLACE_TOKEN"
};
const WITHDRAWAL_ERROR_ACTIONS = {
  RELEASES_WITHDRAW_ERROR: "RELEASES_WITHDRAW_ERROR",
  REFFERALS_WITHDRAW_ERROR: "REFFERALS_WITHDRAW_ERROR"
};
const TRANSACTION_ERROR_ACTIONS = {
  TRANSACTION_ERROR: "TRANSACTION_ERROR"
};
const ARTIST_VERIFICATION_ERROR_ACTIONS = {
  ARTIST_VERIFICATION_ADMIN_ERROR: "ARTIST_VERIFICATION_ADMIN_ERROR",
  ARTIST_VERIFICATION_ARTIST_ERROR: "ARTIST_VERIFICATION_ARTIST_ERROR",
  ARTIST_VERIFICATION_TWITTER_ERROR: "ARTIST_VERIFICATION_TWITTER_ERROR",
  ARTIST_VERIFICATION_INSTAGRAM_ERROR: "ARTIST_VERIFICATION_INSTAGRAM_ERROR"
};
const GLOBAL_ERROR_ACTIONS = {
  GLOBAL_PAGE_CRASH: "GLOBAL_PAGE_CRASH"
};
const SEARCH_ERROR_ACTIONS = {
  INITIAL_SEARCH_RESULTS_FETCH_ERROR: "INITIAL_SEARCH_RESULTS_FETCH_ERROR",
  SEARCH_RESULTS_FETCH_ERROR: "SEARCH_RESULTS_FETCH_ERROR",
  TOP_SEARCH_RESULTS_FETCH_ERROR: "TOP_SEARCH_RESULTS_FETCH_ERROR"
};
const AUDIO_ERROR_ACTIONS = {
  AUDIO_FETCH_ERROR: "AUDIO_FETCH_ERROR",
  AUDIO_PLAYBACK_ERROR: "AUDIO_PLAYBACK_ERROR"
};
const PLAYLIST_ERROR_ACTIONS = {
  PLAYLIST_PAGE_FETCH_ERROR: "PLAYLIST_PAGE_FETCH_ERROR",
  PLAYLIST_PREVIEW_FETCH_ERROR: "PLAYLIST_PREVIEW_FETCH_ERROR",
  PLAYLIST_VIRAL_CHARTS_FETCH_ERROR: "PLAYLIST_VIRAL_CHARTS_FETCH_ERROR"
};
const MISCELLANEOUS_ERROR_ACTIONS = {
  BACKED_ARTISTS_FETCH_ERROR: "BACKED_ARTISTS_FETCH_ERROR",
  FOLLOW_UNFOLLOW_ERROR: "FOLLOW_UNFOLLOW_ERROR",
  SUBSCRIBE_UNSUBSCRIBE_ERROR: "SUBSCRIBE_UNSUBSCRIBE_ERROR",
  AUDIENCE_FETCH_ERROR: "AUDIENCE_FETCH_ERROR",
  VERIFY_NOTIFICATION_EMAIL_ERROR: "VERIFY_NOTIFICATION_EMAIL_ERROR",
  UNHANDLED_NOTIFICATION_ITEM: "UNHANDLED_NOTIFICATION_ITEM",
  USER_BACKEND_PERSISTED_DATA_FETCH_ERROR: "USER_BACKEND_PERSISTED_DATA_FETCH_ERROR",
  USER_BACKEND_PERSISTED_DATA_UPDATE_ERROR: "USER_BACKEND_PERSISTED_DATA_UPDATE_ERROR"
};
const POSTING_ERROR_ACTIONS = {
  UPVOTING_POST_FAILED: "UPVOTING_POST_FAILED",
  UPVOTING_POST_COMMENT_FAILED: "UPVOTING_POST_COMMENT_FAILED",
  REPLY_POST_COMMENT_FAILED: "REPLY_POST_COMMENT_FAILED",
  REPLY_POST_FAILED: "REPLY_POST_FAILED",
  DELETE_POST_FAILED: "DELETE_POST_FAILED",
  DELETE_POST_COMMENT_FAILED: "DELETE_POST_COMMENT_FAILED",
  CREATE_POST_FAILED: "CREATE_POST_FAILED"
};
const getErrorActionsForPillar = (pillar) => {
  switch (pillar) {
    case "ARTIST_VERIFICATION":
      return ARTIST_VERIFICATION_ERROR_ACTIONS;
    case "AUTH":
      return AUTH_ERROR_ACTIONS;
    case "EDIT_RELEASE":
      return EDIT_RELEASE_ERROR_ACTIONS;
    case "UPLOAD_RELEASE":
      return UPLOAD_RELEASE_ERROR_ACTIONS;
    case "MINTING":
      return MINTING_ERROR_ACTIONS;
    case "WITHDRAWAL":
      return WITHDRAWAL_ERROR_ACTIONS;
    case "TRANSACTION":
      return TRANSACTION_ERROR_ACTIONS;
    case "GLOBAL":
      return GLOBAL_ERROR_ACTIONS;
    case "AUDIO":
      return AUDIO_ERROR_ACTIONS;
    case "POSTING":
      return POSTING_ERROR_ACTIONS;
    default:
      return exhaustiveGuard(pillar);
  }
};
const UPLOAD_RELEASE_INFO_ACTIONS = {
  RELEASE_DRAFT_DEPLOY_CLICK_START: "RELEASE_DRAFT_DEPLOY_CLICK_START",
  RELEASE_DRAFT_DEPLOY_SPLIT_START: "RELEASE_DRAFT_DEPLOY_SPLIT_START",
  RELEASE_DRAFT_DEPLOY_SPLIT_COMPLETE: "RELEASE_DRAFT_DEPLOY_SPLIT_COMPLETE",
  RELEASE_DRAFT_UPLOAD_TO_ARWEAVE_START: "RELEASE_DRAFT_UPLOAD_TO_ARWEAVE_START",
  RELEASE_DRAFT_UPLOAD_TO_ARWEAVE_COMPLETE: "RELEASE_DRAFT_UPLOAD_TO_ARWEAVE_COMPLETE",
  RELEASE_DRAFT_DEPLOY_EDITION_START: "RELEASE_DRAFT_DEPLOY_EDITION_START",
  RELEASE_DRAFT_DEPLOY_EDITION_COMPLETE: "RELEASE_DRAFT_DEPLOY_EDITION_COMPLETE",
  RELEASE_UPLOAD_CREATE_DRAFT: "RELEASE_UPLOAD_CREATE_DRAFT",
  RELEASE_UPLOAD_SAVE_STEP: "RELEASE_UPLOAD_SAVE_STEP",
  RELEASE_UPLOAD_PREVIOUS_STEP: "RELEASE_UPLOAD_PREVIOUS_STEP",
  RELEASE_UPLOAD_PREVIEW_CLICK: "RELEASE_UPLOAD_PREVIEW_CLICK",
  RELEASE_UPLOAD_DEPLOY_CLICK: "RELEASE_UPLOAD_DEPLOY_CLICK",
  RELEASE_UPLOAD_DEPLOY_CONFIRM: "RELEASE_UPLOAD_DEPLOY_CONFIRM",
  RELEASE_UPLOAD_DEPLOY_SUCCESS: "RELEASE_UPLOAD_DEPLOY_SUCCESS",
  RELEASE_UPLOAD_PRESALE_CHAMGED: "RELEASE_UPLOAD_PRESALE_CHAMGED"
};
const EDIT_RELEASE_INFO_ACTIONS = {
  EDIT_RELEASE_PREVIOUS_STEP: "EDIT_RELEASE_PREVIOUS_STEP",
  EDIT_RELEASE_SAVED_STEP: "EDIT_RELEASE_SAVED_STEP",
  EDIT_RELEASE_UPDATE_CLICK: "EDIT_RELEASE_UPDATE_CLICK",
  EDIT_RELEASE_UPDATE_CONFIRM: "EDIT_RELEASE_UPDATE_CONFIRM",
  EDIT_RELEASE_UPDATE_START: "EDIT_RELEASE_UPDATE_START",
  EDIT_RELEASE_SPLITS_CONFIRM: "EDIT_RELEASE_SPLITS_CONFIRM",
  EDIT_RELEASE_TRANSACTION_START: "EDIT_RELEASE_TRANSACTION_START",
  EDIT_RELEASE_TRANSACTION_END: "EDIT_RELEASE_TRANSACTION_END"
};
const AUTH_INFO_ACTIONS = {
  LOGGED_IN: "LOGGED_IN",
  LOGGED_OUT: "LOGGED_OUT"
};
const MINTING_INFO_ACTIONS = {
  EDITION_MINT: "EDITION_MINT",
  ARTIST_CONTRACT_MINT: "ARTIST_CONTRACT_MINT",
  GENERATE_PAPER_KEY: "GENERATE_PAPER_KEY",
  SAM_SELL_EDITION: "SAM_SELL_EDITION",
  SAM_MINT_EDITION: "SAM_MINT_EDITION",
  ONRAMP_MODAL_CLICK: "ONAUTHAMP_MODAL_CLICK",
  SHARE_COMMENT_TO_TWITTER: "SHARE_COMMENT_TO_TWITTER",
  COMMENT_TIMESLOT_SELECTED: "COMMENT_TIMESLOT_SELECTED",
  COMMENT_SET: "COMMENT_SET",
  SET_REFERRAL_SOURCE_SUCCESS: "SET_REFERRAL_SOURCE_SUCCESS"
};
const WITHDRAWAL_INFO_ACTIONS = {
  WITHDRAW_RELEASE: "WITHDRAW_RELEASE"
};
const ARTIST_VERIFICATION_INFO_ACTIONS = {
  APPLICATION_ACCEPTED: "APPLICATION_ACCEPTED",
  APPLICATION_REJECTED: "APPLICATION_REJECTED",
  TWITTER_VERIFY_SUCCESS: "TWITTER_VERIFY_SUCCESS",
  INSTAGRAM_VERIFY_SUCCESS: "INSTAGRAM_VERIFY_SUCCESS",
  EMAIL_VERIFY_SUCCESS: "EMAIL_VERIFY_SUCCESS",
  SUBMITTED_APPLICATION: "SUBMITTED_APPLICATION"
};
const AUDIO_INFO_ACTIONS = {
  AUDIO_FETCH_DATA: "AUDIO_ENGINE_FETCH",
  AUDIO_ENGINE_LOAD: "AUDIO_ENGINE_LOAD",
  AUDIO_ENGINE_PLAY: "AUDIO_ENGINE_PLAY",
  AUDIO_ENGINE_RETRY: "AUDIO_ENGINE_RETRY",
  AUDIO_ENGINE_NEXT_TRACK: "AUDIO_ENGINE_NEXT_TRACK",
  AUDIO_ENGINE_PREV_TRACK: "AUDIO_ENGINE_PREV_TRACK"
};
const PLAYLIST_INFO_ACTIONS = {
  PLAYLIST_HERO_PLAY_CLICK: "PLAYLIST_HERO_PLAY_CLICK",
  PLAYLIST_HERO_MINTS_DRIVEN_CLICK: "PLAYLIST_HERO_MINTS_DRIVEN_CLICK",
  PLAYLIST_PAGE_ROW_PLAY_CLICK: "PLAYLIST_PAGE_ROW_PLAY_CLICK",
  PLAYLIST_PREVIEW_MINTS_DRIVEN_CLICK: "PLAYLIST_PREVIEW_MINTS_DRIVEN_CLICK",
  PLAYLIST_PREVIEW_PLAY_CLICK: "PLAYLIST_PREVIEW_PLAY_CLICK",
  PLAYLIST_PREVIEW_ROW_PLAY_CLICK: "PLAYLIST_PREVIEW_ROW_PLAY_CLICK",
  PLAYLIST_PREVIEW_VIEW_MORE_CLICK: "PLAYLIST_PREVIEW_VIEW_MORE_CLICK",
  PLAYLIST_CARD_PLAY_CLICK: "PLAYLIST_CARD_PLAY_CLICK",
  PLAYLIST_CARD_MINTS_DRIVEN_CLICK: "PLAYLIST_CARD_MINTS_DRIVEN_CLICK",
  PLAYLIST_CHART_CARD_PLAY_CLICK: "PLAYLIST_CHART_CARD_PLAY_CLICK",
  PLAYLIST_CHART_CARD_MINTS_DRIVEN_CLICK: "PLAYLIST_CHART_CARD_MINTS_DRIVEN_CLICK"
};
const ARTIST_DASHBOARD_ACTIONS = {
  DOWNLOAD_ARTIST_COMMUNITY_CSV_FILE: "DOWNLOAD_ARTIST_COMMUNITY_CSV_FILE"
};

export { ARTIST_DASHBOARD_ACTIONS, ARTIST_VERIFICATION_ERROR_ACTIONS, ARTIST_VERIFICATION_INFO_ACTIONS, AUDIO_ERROR_ACTIONS, AUDIO_INFO_ACTIONS, AUTH_ERROR_ACTIONS, AUTH_INFO_ACTIONS, EDIT_RELEASE_ERROR_ACTIONS, EDIT_RELEASE_INFO_ACTIONS, ERROR_TYPE, FEATURES, GLOBAL_ERROR_ACTIONS, MINTING_ERROR_ACTIONS, MINTING_INFO_ACTIONS, MISCELLANEOUS_ERROR_ACTIONS, PILLARS, PLAYLIST_ERROR_ACTIONS, PLAYLIST_INFO_ACTIONS, POSTING_ERROR_ACTIONS, SEARCH_ERROR_ACTIONS, TRANSACTION_ERROR_ACTIONS, UPLOAD_RELEASE_ERROR_ACTIONS, UPLOAD_RELEASE_INFO_ACTIONS, WITHDRAWAL_ERROR_ACTIONS, WITHDRAWAL_INFO_ACTIONS, getErrorActionsForPillar };
